import React from 'react';
import { Breakpoint } from './Breakpoint';

interface IProps {}

export const TabletMobile = (props: React.PropsWithChildren<IProps>): JSX.Element => {
  return <Breakpoint name="tabletMobile">{props.children}</Breakpoint>;
};
